import { render, staticRenderFns } from "./EmailComponent.vue?vue&type=template&id=acfc6d4a&scoped=true"
import script from "./EmailComponent.vue?vue&type=script&lang=js"
export * from "./EmailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfc6d4a",
  null
  
)

export default component.exports